import { allPortfolio } from "@/data/portfolio";
import Image from "next/image";
import { useTranslation } from "@/app/i18n/i18n-client";

export default function ProjectDetails({ portfolioSlug, locale }) {
  const { t } = useTranslation(locale, "projects");

  // Find the portfolio item based on the slug
  const portfolioItem =
    allPortfolio.find((elm) => elm.slug === portfolioSlug) || allPortfolio[0];

  return (
    <div className="project-details-page-area space">
      <div className="container">
        {/* Hero Section */}
        <div className="col-lg-12">
          <h1 className="hero-title wow img-custom-anim-left animated">
            {t(portfolioItem.title, "Untitled Project")}
          </h1>
          <div className="hero-3-thumb wow img-custom-anim-top animated">
            <Image
              width={1296}
              height={520}
              className="w-100"
              src={portfolioItem.heroImage}
              alt={t("heroImageAlt", "Project Hero Image")}
            />
          </div>
          <h2 className="title-area text-center wow img-custom-anim-fade animated">
            {t(portfolioItem.type)}
          </h2>
        </div>

        {/* Details Section */}
        <div className="row justify-content-between flex-row-reverse">
          {/* Info Section */}
          <div className="col-xl-3 col-lg-4">
            <div className="project-details-info mb-lg-0 mb-40">
              <ul className="list-wrap">
                <li>
                  <span>{t("category", "Category")}:</span>
                  {t(portfolioItem.category)}
                </li>
                <li>
                  <span>{t("client", "Client")}:</span>
                  {t(portfolioItem.client)}
                </li>
                <li>
                  <span>{t("date", "Date")}:</span>
                  {t(portfolioItem.date)}
                </li>
              </ul>
            </div>
          </div>

          {/* Main Content Section */}
          <div className="col-lg-8">
            <div className="title-area mb-35">
              <h3>{t("about")}</h3>
              <p className="sec-text mt-30">
                {t(portfolioItem.description)}
              </p>
            </div>
            <h3>{t("title", "Challenge & Solution")}</h3>
            <p className="sec-text mb-n1">
              {t(portfolioItem.challenge)}
            </p>
            <h3 className="mt-35">{t("result")}</h3>
            <p className="sec-text mb-n1">
              {t(portfolioItem.result)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
